module.exports = __webpack_public_path__ + "static/media/02-1-galeria-02-santa-fe-mobile@2x.5363ca33.jpg";